import { toRaw } from 'vue'

/**
 * Recursively unwrap Vue reactive proxies to get plain objects.
 * Preserves Date objects and other non-proxy values.
 */
export function deepToRaw<T>(obj: T): T {
  const raw = toRaw(obj)
  if (raw == null || typeof raw !== 'object') return raw
  if (raw instanceof Date) return new Date(raw.getTime()) as T
  if (Array.isArray(raw)) {
    return raw.map((item) => deepToRaw(item)) as T
  }
  const result: Record<string, unknown> = {}
  for (const key of Object.keys(raw)) {
    result[key] = deepToRaw((raw as Record<string, unknown>)[key])
  }
  return result as T
}
